import React, { useMemo } from 'react'
import { Route } from 'react-router-dom'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

import PiLog from './PiLog'
import PiImportData from './PiImportData'
import PiTagScreen from './PiTagScreen'
import PiMonthlySummary from './pimonsummary/PiMonthlySummary'

export const PiWindContainer = ({ actionPermits, envConfig }) => {
  const hasPiAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.PI_READ_TAG_MANAGEMENT,
          ScreenPermissions.PI_WRITE_TAG_MANAGEMENT,
          ScreenPermissions.PI_DATA,
          ScreenPermissions.PI_DATA_IMPORT,
          ScreenPermissions.PI_READ_MONTHLY_SUMMARY,
          ScreenPermissions.PI_WRITE_MONTHLY_SUMMARY,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasPiImportDataAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.PI_DATA,
          ScreenPermissions.PI_DATA_IMPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasPiTagManagementAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.PI_READ_TAG_MANAGEMENT,
          ScreenPermissions.PI_WRITE_TAG_MANAGEMENT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasPiMonthlySummaryAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.PI_READ_MONTHLY_SUMMARY,
          ScreenPermissions.PI_WRITE_MONTHLY_SUMMARY,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <React.Fragment>
      {hasPiMonthlySummaryAccess && (
        <Route exact path="/pi-monthly-summary" component={PiMonthlySummary} />
      )}
      {hasPiAccess && <Route exact path="/pi-log" component={PiLog} />}
      {hasPiImportDataAccess && (
        <Route exact path="/pi-import" component={PiImportData} />
      )}
      {hasPiTagManagementAccess && (
        <Route exact path="/pi-tag-manage" component={PiTagScreen} />
      )}
    </React.Fragment>
  )
}
